import apiHandler from "../core/apiHandler";

const documentApi = apiHandler('document-sequences');
export default documentApi;
